import { WorkspacePlaceholder } from './WorkspacePlaceholder';
import { WorkspaceShell } from './WorkspaceShell';

export function AnalysisWorkspace(): JSX.Element {
  return (
    <WorkspaceShell title="Analisis para Decision" status="shell">
      <WorkspacePlaceholder
        title="Analisis para Decision"
        description="Interpretar datos territoriales para detectar deficits, comparar escalas y orientar decisiones."
        capabilities={[
          'Indicadores territoriales',
          'Analisis multiescalar: proyecto, zona, segmento, entidad',
          'Deteccion de prioridades y deficits',
          'Preguntas territoriales orientadas a decision',
          'Exportacion de hallazgos e informes',
        ]}
      />
    </WorkspaceShell>
  );
}
